<script>
import { defineRule, configure } from 'vee-validate';
import { localize } from '@vee-validate/i18n';
    export default {

        data() {
            return {
                unsubscribe: this.type,
                // success: false,
                success: true,
                formEl: null,
                formError: '',
                formData: {
                    email: 'test@test.fr',
                    confirm: false,
                    reason: '',
                    other: '',
                    newsletter: ''
                }
            }
        },

        created () {

          defineRule('reason', (value, { other, reason }) => {
            // Validation logic
            return other !== '' || reason !== '' ? true : 'A reason must be defined';
          });

          configure({
            generateMessage: localize('fr', {
              attributes: {
                reason: 'Une raison',
                other: 'Ce champ'
              }
            })
          });
        },
        mounted () {
            // this.formEl = this.$el.querySelector("form")
            // this.success = this.formEl.querySelector(".webform-confirmation") !== null
        },

        methods: {
            submit() {

                this.formError = ''

                if (this.formData.reason !== '' || this.formData.other !== '') {

                    this.$validator.validateAll().then((result) => {

                        if (result) {
                            // Fill out Drupal form inputs
                            for (let [key, value] of Object.entries(this.formData)) {
                                let inputs = this.formEl.querySelectorAll(`[name='${key.toLowerCase()}']`)
                                switch (key) {
                                    case 'confirm':
                                        inputs[0].setAttribute('checked', value ? 'checked' : '')
                                        break
                                    case 'reason':
                                        inputs.forEach((i, k) => {
                                            if (i.value === value)
                                                i.setAttribute('checked', 'checked')
                                            else
                                                i.removeAttribute('checked')
                                        })
                                        break
                                    case 'newsletter':
                                        inputs.forEach((i, k) => {
                                            if (i.value === value)
                                                i.setAttribute('checked', 'checked')
                                        })
                                        break
                                    default:
                                        inputs[0].value = value
                                        break

                                }

                            }
                            this.formEl.submit()
                        }
                    })
                } else {
                    this.formError = 'Vous devez choisir une raison'
                }
            },
            clearReason () {
                this.formData.reason = ''
            },
            clearOther () {
                this.formData.other = ''
            }
        }
    }
</script>

<style lang="sass">
@import ../../common/styles/mixins
@import ../../common/styles/settings
@import form-unsubscribe

</style>
